import { Button, Spinner } from 'react-bootstrap'
import { useQuery } from 'react-query'
import { useIntl } from 'react-intl'
import { requestManagementUsers, requestManagementUserSyncCommercials } from '../../requests/requests'
import { useState } from 'react'
import { AddUserModal } from '../../components/users/AddUserModal'
import { SingleUser } from './SingleUser'
import { usePagination } from '../../hooks/usePagination'
import { Link } from 'react-router-dom'
import { ManagementUser } from '../../models/managementUsers'
import { configStaleTime } from '../../constants'
import { BreadcumbsSection } from '../../components/BreadcumbsSection'
import { sortObjectsByStrAttr, UserHasPermission } from '../../helpers/utils'
import { PagePermission } from '../../models/models'
import { useAuth } from '../../modules/auth'
import { ToastifyCaller, ToastifyType } from '../../components/Toastify'

export function ListUsers() {
  const intl = useIntl()
  const { auth } = useAuth()
  const [show, setShow] = useState(false)
  const [inSyncProcess, setInSyncProcess] = useState(false);

  const {
    isLoading,
    error,
    data,
    refetch,
  } = useQuery('listUsers', () => requestManagementUsers(), {
    refetchOnWindowFocus: false,
    staleTime: configStaleTime,
  })

  const {
    currentItems: users,
    handlePaginationNumberClick,
    handlePreviousClick,
    handleNextClick,
    chunkedArray,
    currentPage,
  } = usePagination(sortObjectsByStrAttr(data?.data as ManagementUser[], 'firstName', 'asc'), 5)

  return (
    <>
      <BreadcumbsSection title={intl.formatMessage({ id: 'LIST_USERS.TITLE' })} breadcrumbItems={[intl.formatMessage({ id: 'MENU.DASHBOARD' }), intl.formatMessage({ id: 'LIST_USERS.TITLE' })]}>
        <div>
          <Button onClick={() => setShow(true)} className='my-2 p-5 me-3'>
            {intl.formatMessage({ id: 'LIST_USERS.ADD' })}
          </Button>
          {UserHasPermission(auth, PagePermission.SINCRONIZE_COMMERCIALS) && <Button className={`my-2 position-relative p-5 ${inSyncProcess ? 'disabled' : ''}`} onClick={async () => {
            window['showToastOnError'] = false;
            setInSyncProcess(true);
            let syncOK = false;
            try {
              await requestManagementUserSyncCommercials();
              syncOK = true;
            } catch(Exception) {
              syncOK = false;
            } finally {
              if (syncOK) {
                ToastifyCaller(intl.formatMessage({ id: 'GENERAL.SYNC_COMMERCIALS_OK' }), ToastifyType.SUCCESS)
              } else {
                if (window['lastError']) {
                  ToastifyCaller(window['lastError'], ToastifyType.ERROR)
                }
              }
              setInSyncProcess(false);
            }
          }}>
            {intl.formatMessage({ id: 'GENERAL.SYNC_COMMERCIALS' })}
            {inSyncProcess && <Spinner animation='border' className='mx-3' size='sm' />}
          </Button>}
        </div>
      </BreadcumbsSection>
      <div className='card card-flush py-4 flex-row-fluid overflow-hidden'>
        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <AddUserModal
              show={show}
              onHide={() => setShow(false)}
              refetch={refetch}
            />
            <table className='table align-middle table-row-dashed fs-6 gy-5 mb-0'>
              <thead>
                <tr className='text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0'>
                  <th className='min-w-175px'>
                    {intl.formatMessage({ id: 'LIST_USERS.NAME' })}
                  </th>
                  <th className='min-w-70px'>
                    {intl.formatMessage({ id: 'LIST_USERS.ROLE' })}
                  </th>
                  <th className='min-w-70px text-end'>
                    {intl.formatMessage({ id: 'LIST_USERS.ACTIONS' })}
                  </th>
                </tr>
              </thead>
              <tbody className='fw-semibold text-gray-600'>
                {isLoading && (
                  <tr>
                    <td colSpan={3}>{intl.formatMessage({ id: 'FETCH.LOADING' })}</td>
                  </tr>
                )}
                {error ? (
                  <tr>
                    <td colSpan={3}>{intl.formatMessage({ id: 'FETCH.ERROR' })}</td>
                  </tr>
                ) : (
                  false
                )}
                {
                  users && users.map((user: ManagementUser) => (
                    <SingleUser
                      user={user}
                      key={user.id}
                      refetch={refetch}
                    />
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className='card card-flush py-4 flex-row-fluid overflow-hidden mt-5'>
        <div className='card-body py-0'>
          {/* PAGINATION COMPONENT */}
          <ul className='pagination'>
            <li className='page-item previous' onClick={() => handlePreviousClick()}>
              <Link to={'#'} className='page-link'>
                <i className='previous' />
              </Link>
            </li>

            {chunkedArray?.map((_newsChunk: any, index: number) => (
              <li
                onClick={() => handlePaginationNumberClick(index + 1)}
                key={index}
                className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
              >
                <Link to={'#'} className='page-link'>
                  {index + 1}
                </Link>
              </li>
            ))}

            <li className='page-item next' onClick={() => handleNextClick()}>
              <Link to={'#'} className='page-link'>
                <i className='next' />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
